import { render, staticRenderFns } from "./CommentCardDelete.vue?vue&type=template&id=09b2a018&scoped=true&"
import script from "./CommentCardDelete.vue?vue&type=script&lang=js&"
export * from "./CommentCardDelete.vue?vue&type=script&lang=js&"
import style0 from "./CommentCardDelete.vue?vue&type=style&index=0&id=09b2a018&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b2a018",
  null
  
)

export default component.exports